import React from "react";
import { useVideo } from "../../context/VideoContext";
import { useShadowTechnique } from "../../context/ShadowTechniqueContext";
import "./SpeedDial.css";

const SpeedDial = ({ onOpenShadowSettings }) => {
  // دریافت prop
  const { setShowSpeedDial, setShowSettings } = useVideo();
  const { setShowProcessBox } = useShadowTechnique();

  const dialItems = [
    { icon: "fa-sliders-h", label: "تنظیمات", action: "settings" },
    { icon: "fa-palette", label: "تم", action: "theme" },
    { icon: "fa-filter", label: "فیلترها", action: "filters" },
    { icon: "fa-keyboard", label: "میانبرها", action: "shortcuts" },
    { icon: "fa-mask", label: "تکنیک سایه", action: "shadow" },
    { icon: "fa-info-circle", label: "اطلاعات", action: "info" },
    { icon: "fa-download", label: "دانلود", action: "download" },
  ];

  const handleItemClick = (action) => {
    if (action === "settings") {
      setShowSettings(true);
    } else if (action === "shadow") {
      if (onOpenShadowSettings) {
        onOpenShadowSettings(); // فراخوانی تابع از والد
      }
    }
    setShowSpeedDial(false);
  };

  return (
    <div className="speed-dial-overlay" onClick={() => setShowSpeedDial(false)}>
      <div className="speed-dial" onClick={(e) => e.stopPropagation()}>
        <button
          className="speed-dial-close"
          onClick={() => setShowSpeedDial(false)}
        >
          <i className="fas fa-times"></i>
        </button>

        <div className="dial-items">
          {dialItems.map((item, index) => (
            <button
              key={index}
              className="dial-item"
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => handleItemClick(item.action)}
            >
              <i className={`fas ${item.icon}`}></i>
              <span className="dial-label">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SpeedDial;
